import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center text-foreground-950 text-xl">
                <i className="ri-film-fill" />
              </span>
              <span className="font-heading text-xl font-extrabold text-background-50">神马影视</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              神马影视是一个提供高清电影、电视剧在线观看与影视资讯浏览的综合影视平台。
              我们致力于为观众带来最新、最全的影视资源，让每一次打开都遇见好故事。
            </p>
            <p className="mt-4 text-xs text-background-300">
              本站为演示站点，影片、评分及资讯均为示例数据，播放功能待正式后端接口接入。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50 mb-4">内容导航</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/movie" className="text-background-200 hover:text-accent-400 transition-colors">电影频道</Link></li>
              <li><Link to="/tv" className="text-background-200 hover:text-accent-400 transition-colors">电视剧频道</Link></li>
              <li><Link to="/news" className="text-background-200 hover:text-accent-400 transition-colors">影视资讯</Link></li>
              <li><Link to="/search" className="text-background-200 hover:text-accent-400 transition-colors">搜索影片</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50 mb-4">关于我们</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="text-background-200 hover:text-accent-400 transition-colors">平台介绍</Link></li>
              <li><Link to="/about" className="text-background-200 hover:text-accent-400 transition-colors">联系方式</Link></li>
              <li><Link to="/about" className="text-background-200 hover:text-accent-400 transition-colors">使用声明</Link></li>
              <li><Link to="/about" className="text-background-200 hover:text-accent-400 transition-colors">版权信息</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© {year} 神马影视 ShenMa YingShi. 保留所有权利。</p>
          <p>本站内容仅供学习交流演示使用</p>
        </div>
      </div>
    </footer>
  );
}